import { InjectionKey } from 'vue';
import { useExternalEventEvent } from './composables/useExternalEventEvent';
import { useExternalEventSeries } from './composables/useExternalEventSeries';

export const externalEventSeriesKey = Symbol() as InjectionKey<ReturnType<typeof useExternalEventSeries>>;
export const externalEventKey = Symbol() as InjectionKey<ReturnType<typeof useExternalEventEvent>>;
